module.exports = __webpack_public_path__ + "static/media/K0006-03_V01-Straumann Surgical - Implants_RGB_Transparent.d53ddad1.png";